import { useState, useRef } from 'react';

interface NotificationState {
  isVisible: boolean;
  type: 'success' | 'error' | 'info';
  message: string;
}

interface UseNotificationReturn {
  notification: NotificationState;
  showNotification: (type: 'success' | 'error' | 'info', message: string) => void;
  hideNotification: () => void;
  targetRef: React.RefObject<HTMLElement>;
}

export const useNotification = (): UseNotificationReturn => {
  const [notification, setNotification] = useState<NotificationState>({
    isVisible: false,
    type: 'success',
    message: ''
  });

  const targetRef = useRef<HTMLElement>(null);

  const showNotification = (type: 'success' | 'error' | 'info', message: string) => {
    setNotification({
      isVisible: true,
      type,
      message
    });
  };

  const hideNotification = () => {
    setNotification(prev => ({ ...prev, isVisible: false }));
  };

  return {
    notification,
    showNotification,
    hideNotification,
    targetRef
  };
}; 